//@ts-nocheck
import { useRouter } from 'next/router'
import type { FC, PropsWithChildren } from 'react'
import { useContext, useEffect, useState } from 'react'

import { CwsHeaderWrapperContext } from 'cms-web-styleguide/dist/components/CwsHeader/CwsHeaderWrapper/CwsHeaderWrapperContext'
import { CwsDropdown } from 'cms-web-styleguide/dist/components/CwsForm/CwsDropdown/CwsDropdown'
import { CwsIcon } from 'cms-web-styleguide/dist/components/CwsIcon/CwsIcon'
import { CwsDropdownButton } from 'cms-web-styleguide/dist/components/CwsForm/CwsDropdown/CwsDropdownButton/CwsDropdownButton'
import { CwsDropdownMenu } from 'cms-web-styleguide/dist/components/CwsForm/CwsDropdown/CwsDropdownMenu/CwsDropdownMenu'

export const HeaderMenuMobile: FC<PropsWithChildren> = (props) => {
  const { children } = props
  const router = useRouter()
  const [open, setOpen] = useState(false)

  const { mobile, setDisableHeader, setOpenLocaleSelector } = useContext(CwsHeaderWrapperContext)

  const handleClick = (status) => {
    setOpen(status)

    setDisableHeader(status)

    if (open) {
      setOpenLocaleSelector(false)
    }
  }

  const handleOutsideClick = () => {
    if (open) {
      setDisableHeader(false)
    }
  }
  useEffect(() => {
    const handleRouteChange = () => {
      handleClick(false)
    }
    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events, router.locale])

  return (
    <CwsDropdown
      className="cws-header__dropdown"
      id="header-menu"
      onClickOutside={handleOutsideClick}
      open={open}
      setOpen={handleClick}
    >
      <CwsDropdownButton aria-label="Menu" className="cws-header__dropdown-button" data-analytics-id="Search">
        <CwsIcon
          className="cws-d-flex-shrink-0"
          color={mobile && !open ? 'white' : 'midnight'}
          icon="menu-burger"
          size="24px"
        />
      </CwsDropdownButton>
      {open ? (
        <CwsDropdownMenu className="cws-header__dropdown-menu" position="none" variant="div">
          <div className="cws-dropdown__menu-inner">{children}</div>
        </CwsDropdownMenu>
      ) : null}
    </CwsDropdown>
  )
}
